import { Helmet } from 'react-helmet-async';
import Z36HomepageView from 'src/sections/_z36/view/z36-landing-view';

// ----------------------------------------------------------------------

export default function HomePage() {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": ["Organization", "LocalBusiness"],
    "name": "Zebra360 Digitalagentur",
    "url": "https://www.zebra360.de",
    "logo": "https://www.zebra360.de/assets/images/logo.svg",
    "description": "Ihr Partner für digitale Transformation in der Gastronomie & für KMU",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Konrad-Adenauer-Str. 4",
      "addressLocality": "Bad Abbach",
      "addressRegion": "Bayern",
      "postalCode": "93077",
      "addressCountry": "DE"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "telephone": "+4994059551343",
      "email": "info@zebra360.de",
      "areaServed": "DE",
      "availableLanguage": ["German", "English", "Turkish"]
    },
    "sameAs": [
      "https://www.xing.com/profile/Alper_Koyuncu"
    ],
    "priceRange": "€€-€€€",
    "image": [
      "https://www.zebra360.de/assets/images/og-home.jpg",
      "https://www.zebra360.de/assets/images/home-hero.webp"
    ]
  };

  return (
    <>
      <Helmet>
        <title>Digitale Lösungen für Restaurants & KMU | Zebra360</title>
        <meta 
          name="description" 
          content="KI-gestützte Lösungen für Gastronomie & Handel: Voice Agents, Webdesign & Prozessautomatisierung. Jetzt kostenlose Analyse sichern ➔ 24/7 Support" 
        />
        <meta 
          name="keywords" 
          content="KI-Beratung, Webdesign Agentur, Digitale Transformation, Restaurant Automatisierung, Voice Agent Lösung, Responsive Websites, E-Commerce Entwicklung, Agile Projektmanagement" 
        />
        <meta name="author" content="Zebra360 Digitalagentur" />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>

        {/* Social Meta */}
        <meta property="og:title" content="Zebra360 - Digitale Experten für Gastronomie & Handel" />
        <meta property="og:description" content="Mit KI & Automatisierung zum Erfolg: +40% Umsatzsteigerung bei 93% unserer Kunden" />
        <meta property="og:image" content="https://www.zebra360.de/assets/images/og-home.jpg" />
        <meta property="og:url" content="https://www.zebra360.de" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.zebra360.de" />

        {/* Preload Critical Assets */}
        <link rel="preload" href="/fonts/neue-haas-grotesk.woff2" as="font" type="font/woff2" crossorigin />
        <link rel="preload" href="/assets/js/chat-widget.js" as="script" />
      </Helmet>

      <Z36HomepageView />
    </>
  );
}